export const GET_COURSE_FROM_REGION_AND_ITALY = 'GET_COURSE_FROM_REGION_AND_ITALY'
